import React from 'react'

const BoldHeading = ({ Boldheading }) => {
    return (
        <div className="widget-heading">
            <h4  className='annualTitles'>{Boldheading}</h4>
        </div>
    )
}

export default BoldHeading